export default __webpack_public_path__ + "static/media/330_dummy2016-yoga02-de.5fa590c8.png";